import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

// Defaults mirror backend/brand.py; the backend /api/brand response is the single source of truth.
export const DEFAULT_BRAND = {
  app_name: "Private Offer Autopilot",
  company_name: "Transactr",
  source_app_name: "Marketplace Deal Options",
  seller_motion_name: "The Next Level Marketplace Motion",
  handoff_label: "Deal hand-offs",
};

const BrandContext = createContext(DEFAULT_BRAND);

export function BrandProvider({ children }) {
  const [brand, setBrand] = useState(DEFAULT_BRAND);
  useEffect(() => {
    api.get("/brand").then((r) => setBrand({ ...DEFAULT_BRAND, ...r.data })).catch(() => {});
  }, []);
  useEffect(() => { document.title = brand.app_name; }, [brand.app_name]);
  return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
}

export const useBrand = () => useContext(BrandContext);

export function Wordmark({ sub = true, className = "" }) {
  const b = useBrand();
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="wordmark">
      <div className="w-6 h-6 border border-orange-500 flex items-center justify-center rounded-sm shrink-0">
        <div className="w-2 h-2 bg-orange-500 rounded-full tx-pulse-dot" />
      </div>
      <div className="leading-none">
        <div className="font-heading font-black text-[15px] tracking-tight" data-testid="brand-app-name">{b.app_name}</div>
        {sub && <div className="font-mono text-[9px] text-zinc-500 mt-0.5 tracking-[0.18em] uppercase">by {b.company_name}</div>}
      </div>
    </div>
  );
}
